import { reduxLillTypes } from 'src/types';
import { LILL_ADDED, LILL_DELETED, LILL_EDITED, LILL_SET } from '../redux-types/contents.types';

export const lillDefaultState: reduxLillTypes.StateType = {
  lillList: [],
};

export const lillReducer = (state = lillDefaultState, action: reduxLillTypes.ActionType): reduxLillTypes.StateType => {
  switch (action.type) {
    case LILL_SET:
      return {
        ...state,
        lillList: action.payload,
      };
    case LILL_ADDED:
      const exists = state.lillList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        lillList: [action.payload, ...state.lillList],
      };
    case LILL_EDITED:
      const updatedIndex = state.lillList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        lillList: [...state.lillList.slice(0, updatedIndex), action.payload, ...state.lillList.slice(updatedIndex + 1)],
      };
    case LILL_DELETED:
      return {
        ...state,
        lillList: state.lillList.filter((obj) => obj.id !== action.payload),
      };
    default:
      return state;
  }
};
